<template>
	<div class="stock-overlay">
		<img
			src="/images/overlay-arrow.svg"
			alt="overlay-arrow"
			class="overlay-arrow"
		/>

		<button
			class="stock-icon-close"
			@click="$emit('close')"
		>
			<svg
				class="w-[14px] h-[14px]"
				width="20"
				height="20"
				viewBox="0 0 21 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M1.4043 20.2886L19.7891 1.9038"
					stroke="black"
					stroke-width="2"
					stroke-linecap="round"
				/>
				<path
					d="M1.21094 1.71143L19.5957 20.0962"
					stroke="black"
					stroke-width="2"
					stroke-linecap="round"
				/>
			</svg>
		</button>

		<span class="stock-symbol">
			<NuxtLink
				:to="path + '#' + symbol"
				v-if="printLink"
			>
				<b>{{ symbol }}</b>
			</NuxtLink>
			<b v-else>{{ symbol }}</b>
			- {{ market === "NSC" ? "NASDAQ" : "NYSE" }}
		</span>
		<span class="stock-company">{{ name }}</span>
		<div class="stock-price-block">
			<span class="stock-price">${{ lastPrice.toFixed(2) }}</span>
			<span
				:class="[
					'stock-price-change',
					netChange > 0 ? 'positive' : netChange < 0 ? 'negative' : ''
				]"
			>
				{{ netChange > 0 ? "+" : "" }}{{ netChange.toFixed(2) }} ({{
					percentChange > 0 ? "+" : ""
				}}{{ percentChange.toFixed(2) }}%)
			</span>
		</div>
		<span class="stock-market-cap gap-[12px] !flex-row justify-between">
			<div class="inline-flex !text-[16px]">
				<b>Volume:&nbsp;</b>
				{{ formatNumber(volume) }}
			</div>
			<div class="inline-flex !text-[16px]">
				<b>Float:&nbsp;</b>
				{{ formatNumber(float) }}
			</div>
		</span>
		<span class="stock-market-cap">
			<div class="flex mb-[4px] justify-between items-center text-[16px]">
				<b class="text-[16px]">${{ day_low.toFixed(2) }}</b>

				<b>Day Low/High</b>
				<!--  -->
				<b class="text-[16px]">${{ day_high.toFixed(2) }}</b>
			</div>
			<div class="stock-market-balance mb-[4px] text-[16px]">
				<span
					class="stock-market-balance-ball"
					:style="{ left: pricePercetageHighLow + '%' }"
				/>
			</div>
		</span>

		<span class="stock-market-cap !pt-[12px] pb-[0]">
			<button
				@click="store.toggleSignUp()"
				class="bg-blue-300 hover:bg-blue-500 text-white py-[8px] px-[12px] rounded-[8px] text-[18px] font-medium text-center font-semibold"
			>
				Get Free Alerts
			</button>
		</span>
	</div>
</template>

<script setup>
import { store } from "~/src/utils/store";
const { lastPrice, day_high, day_low, symbol } = defineProps({
	market: String,
	symbol: String,
	name: String,
	lastPrice: Number,
	netChange: Number,
	percentChange: Number,
	day_high: Number,
	day_low: Number,
	volume: Number,
	float: Number
});

const pricePercetageHighLow = computed(() => {
	return ((lastPrice - day_low) / (day_high - day_low)) * 100;
});

const printLink = ref(false);

const { path } = useRoute();

onMounted(() => {
	if (process.client) {
		const hasIdOnBody = document.getElementById(symbol);
		if (hasIdOnBody) {
			printLink.value = true;
		}
	}
});
</script>

<style lang="scss">
.overlay-arrow {
	display: none;
	@include breakpoint(lg) {
		position: absolute;
		top: 16px;
		left: -22px;
		z-index: 0;
		transform: rotate(-90deg) scale(0.75);
		height: 32px;
		width: 32px;
		display: block;
	}
}

.stock-market-balance {
	height: 8px;
	width: 100%;
	background-color: $slate-100;
	position: relative;
	border-radius: 8px;
}
.stock-market-balance-ball {
	position: absolute;
	height: 8px;
	width: 8px;
	background-color: $blue-300;
	top: 0;
	border-radius: 8px;
}

.stock-icon-close {
	height: 16px;
	width: 16px;
	position: absolute;
	right: 12px;
	@include breakpoint(lg) {
		display: none;
	}
}
</style>
